// @flow
export const TRANSITION_ENTER_DELAY = 200;
export const TRANSITION_ENTER_DURATION = 600;
export const TRANSITION_EXIT_DURATION = 400;



// WEBPACK FOOTER //
// ./src/components/routing/page-transition/constants.js